__turbopack_context__.v({
  "card": "ActivityCard-module-scss-module__B3uR5q__card",
  "content": "ActivityCard-module-scss-module__B3uR5q__content",
  "cta": "ActivityCard-module-scss-module__B3uR5q__cta",
  "ctaWrapper": "ActivityCard-module-scss-module__B3uR5q__ctaWrapper",
  "image": "ActivityCard-module-scss-module__B3uR5q__image",
  "imageWrapper": "ActivityCard-module-scss-module__B3uR5q__imageWrapper",
  "label": "ActivityCard-module-scss-module__B3uR5q__label",
  "scrim": "ActivityCard-module-scss-module__B3uR5q__scrim",
});
